(function () {
  function splitWords(element) {
    if (!element || element.dataset.split === 'true') {
      return;
    }

    var words = element.textContent.trim().split(/\s+/);
    element.textContent = '';

    words.forEach(function (word, index) {
      var span = document.createElement('span');
      span.className = 'word';
      span.textContent = word;
      element.appendChild(span);
    });

    element.dataset.split = 'true';
  }

  function initBanner(section) {
    if (!section || section.dataset.animated === 'true') {
      return;
    }

    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') {
      return;
    }

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      section.dataset.animated = 'true';
      return;
    }

    var title = section.querySelector('[data-athletes-banner-title]');
    var subtitle = section.querySelector('[data-athletes-banner-subtitle]');
    var stage = section.querySelector('.Athletes_banner_new_stage');
    var shots = section.querySelectorAll('[data-athletes-banner-shot]');

    if (!title || !stage || !shots.length) {
      return;
    }

    splitWords(title);
    window.gsap.registerPlugin(window.ScrollTrigger);

    var computedStyle = getComputedStyle(section);
    var faintColor = computedStyle.getPropertyValue('--athletes-banner-faint').trim();
    var scrub = Number(section.dataset.scrub || 1.6);
    var pinDistance = Number(section.dataset.pinDistance || 2.6);
    var rise = Number(section.dataset.rise || 120);

    var words = title.querySelectorAll('.word');
    // var offsets = [
    //   rise,
    //   rise + 30,
    //   rise + 15,
    //   rise + 45,
    //   rise + 20,
    //   rise + 35
    // ];

    window.gsap.set(words, { color: faintColor });
    if (subtitle) {
      window.gsap.set(subtitle, { opacity: 0 });
    }

    // window.gsap.set(shots, {
    //   yPercent: function (index) {
    //     return offsets[index] || rise;
    //   },
    //   opacity: 0
    // });

    window.gsap.set(shots, {
  opacity: 0,
  scale: 0.9
});

    var timeline = window.gsap.timeline({
      scrollTrigger: {
        trigger: stage,
        start: 'top top',
        end: '+=' + window.innerHeight * pinDistance,
        pin: true,
        scrub: scrub
      }
    });

    // timeline.to(
    //   shots,
    //   {
    //     yPercent: 0,
    //     opacity: 1,
    //     duration: 1,
    //     ease: 'power2.out',
    //     stagger: 0.08
    //   },
    //   0
    // );

    shots.forEach(function (shot, index) {
      timeline.to(
        shot,
        {
          yPercent: -5,
          opacity: 1,
          scale: 1,
          duration: 0.7,
          ease: 'power2.out'
        },
        index * 0.7
      );
    });

    words.forEach(function (word, index) {
      timeline.to(
        word,
        {
          color: '#111',
          duration: 1.8
        },
        index * 1
      );
    });

    if (subtitle) {
      timeline.to(
        subtitle,
        {
          opacity: 1,
          duration: 2,
          ease: 'power2.out'
        },
        1.2
      );
    }

    section.dataset.animated = 'true';
  }

  function initAllBanners() {
    document.querySelectorAll('[data-athletes-banner]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBanners);
  } else {
    initAllBanners();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBanner(event.target.querySelector('[data-athletes-banner]') || event.target);
  });
})();
